(function($) {

  /**
    * Homepage bricks behavior
    *
    */
  Drupal.behaviors.home_formatter_v1 = {
    attach: function(context, settings) {

      var $upnexts = $('.up-next-wrapper'),
        $bricks = $('.brick'),
        $firstBrick = $bricks.first(),
        $lastBrick = $bricks.last(),
        dir = '',
        $previousBrick, // used while scrolling
        $nextBrick, // used while scrolling
        brickid,
        $prevLabel = $('.up-next__previous-label'),
        winheight = $(window).height();

        // Scale headline
      $('.js-homepage__headline h1').fitText(1, {
        maxFontSize: '150px'
      });

      function lazyBrickHeights() {
        // make sure module fills up entire screen
        $('.brick').css({
          'min-height': $(window).height()
        });
      };

      lazyBrickHeights();

      var resizeTimer;
      $(window).resize(function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(lazyBrickHeights, 100);
      });

      $lastBrick.addClass('brick--last');

      // Set/reset brick heights, throttled
      // fullHeightElement is in main-shared.js
      //var lazyBrickHeights = Drupal.ELB.ui.fullHeightElement($('.brick'));
      //$(window).resize(lazyBrickHeights).resize();

      // Landing page body class because template field does not allow us to preprocess page
      if ($('.homepage-bricks').length > 0) {
        $('body').addClass(Drupal.ELB.ui.landing_class); // this gave me cancer
      }

      // logic for class passing
      function toggleLabelClass() {
        // vars for label and item so we can pass classes and styles around
        $upNextLabel = $('.up-next__label');
        $upNextItem = $('.is-opaque .up-next__item');
        var className = $upNextItem.attr('class');
        // check for classes and change our label styles
        if ($upNextItem.hasClass('light')) {
          $upNextLabel.addClass('light');
          $upNextLabel.removeClass('dark');
        }
        if ($upNextItem.hasClass('dark')) {
          $upNextLabel.addClass('dark');
          $upNextLabel.removeClass('light');
        }
      }

      ///
       // Up Next feature
       ///

      // Move our upnext items to a container
      $('.up-next-items').append($upnexts);

      // Start with the proper one highlighted
      $('.up-next-wrapper:nth-child(2)').toggleClass('is-opaque');

      $prevLabel.hide();

      // styling
      toggleLabelClass();

      // starting brick
      $nextBrick = $('.brick').eq(1);

      // Fire a function when we cross a waypoint boundary
      $bricks.waypoint({
        handler: handleHomeWaypoints,
        offset: 0
      })
      .waypoint({
        handler: handleHomeWaypoints,
        offset: -50
      }); // testing

      // A nice abstraction of what happens up/down scrolling on front page
      function handleHomeWaypoints(direction) {

        // check if current slide is first brick
        if ($(this)[0] === $firstBrick[0]) {
          $prevLabel.hide();
        } else {
          $prevLabel.show();
        }
        // check if current slide is last brick
        // hide the up next label
        if ($(this)[0] === $lastBrick[0]) {
          $('.up-next__label').hide();
        }
        else {
          $('.up-next__label').show();
        }


        // set out previous brick element to scroll back to
        $previousBrick = $(this).waypoint('prev');
        // next brick
        $nextBrick = $(this).waypoint('next');
        brickid = $nextBrick.attr('id');
        dir = direction;

        // hide all in order to show just the one we want
        $upnexts.removeClass('is-opaque');
        // select up next widget that corresponds to our brick
        $('.up-next-wrapper[data-brickid=' + brickid + ']').toggleClass('is-opaque');
        // styling
        toggleLabelClass();
      } // handleHomeWaypoints()

      // upnext graphical button
      $('.up-next-wrapper').on('click', function(event) {
        event.preventDefault();
        $.scrollTo($nextBrick, 800, {'axis':'y'});
      });

      // previous item button
      $prevLabel.on('click', function(event) {
        event.preventDefault();
        $.scrollTo($previousBrick, 800, {'axis':'y'});
      });

      ///
       // expandable boutique interaction
       // de-scoped for launch, may be used later if
       // a simple version of boutique is built
       // that does not need to be iframed
       ///
      $boutiqueRef = $('.boutique-reference', context);
      $boutiqueLink = $('.boutique-trigger', context);
      $boutiqueLinkSecond = $('.boutique-trigger-secondary', context);
      $boutiqueCloser = $('.homepage__button-explore--wrapper', context);

      // add ids for the ajax to hit
      // account for click events on main first trigger
      $boutiqueRef.each(function() {
        var thisId = $(this).attr('data-boutique-id'),
        slideAnchor = $(this).closest('.brick').next('.boutique-brick');
        $(this).closest('.brick').next('.boutique-brick').attr('id', 'boutique-reference__id-' + thisId);
        // click scroll
        $boutiqueLink.click(function(e) {
          e.preventDefault();
          $('html,body').delay(600).animate({scrollTop: slideAnchor.offset().top},'slow');
          $(this).hide();
          $(this).next($boutiqueLinkSecond).show();
          $(this).next($boutiqueLinkSecond).addClass('button button-explore open');
          $(slideAnchor).next($boutiqueCloser).delay(1000).show(0);
        });

      });

      // now that we have a loaded boutique let us expand and collapse
      // with no ajax needed
      // manage the secondary triggers
      // close when open
      $boutiqueRef.on('click', '.boutique-trigger-secondary.open', function(e) {
        $(this).addClass('closed').removeClass('open');
        var slideAnchor = $(this).closest('.brick');
        $('html,body').animate({scrollTop: slideAnchor.offset().top},'slow');
        $(this).delay(600).closest('.brick').next('.boutique-brick').slideUp('slow');
        $(this).closest('.brick').next('.boutique-brick').next($boutiqueCloser).hide();
      });
      // open when closed
      $boutiqueRef.on('click', '.boutique-trigger-secondary.closed', function(e) {
        $(this).addClass('open').removeClass('closed');
        var slideAnchor = $(this).closest('.brick').next('.boutique-brick');
        $(this).closest('.brick').next('.boutique-brick').slideDown('slow');
        $('html,body').animate({scrollTop: slideAnchor.offset().top},'slow');
        $(this).closest('.brick').next('.boutique-brick').next($boutiqueCloser).delay(1000).show(0);
      });
      // case of button at bottom of boutique
      $boutiqueCloser.on('click', function(e) {
        var slideAnchor = $(this).prev('.boutique-brick').prev('.brick');
        $('html,body').animate({scrollTop: slideAnchor.offset().top},'slow');
        $(this).hide();
        $(this).delay(600).prev('.boutique-brick').slideUp('slow');
        $(this).prev('.boutique-brick').prev('.brick').find('.boutique-trigger-secondary.open').removeClass('open').addClass('closed');
      });

    } // attach
  }; // Drupal.behaviors.home_formatter_v1

  /**
   * Clicking images on the front page should take a user to the link referenced
   * in the call to action button
   */
  Drupal.behaviors.brick_image_link = {
    attach: function(context, settings) {

      // clicking an img inside a .brick
      $('.brick').on('click', 'img', function(event) {
        // sends you to url from the first cta button we find
        window.location.href = $('a.cta', event.delegateTarget).attr('href');
      });

    } // attach
  }; // Drupal.behaviors.brick_iamge_link

})(jQuery);
